<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='3'></LeftNav>
      <div class="mail-send-history-display">
        <h2>メール送信履歴</h2>
        <div class="info-box">
          <div v-if="page_all_num > 1" class="paging-box">
            <div @click="page_shift(-1)">＜</div>
            <input type="text" v-model="page_num" @change="page_change()">
            <p>／</p>
            <p>{{ page_all_num }}</p>
            <div @click="page_shift(1)">＞</div>
          </div>
        </div>
        <div class="customer-mail-list-box">
          <table>
            <thead>
              <tr>
                <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in page_list">
                <tr :key="item.id">
                  <td class="td-id"><div @click="send_mail_history_detail_disp(item.id)">{{ item.id }}</div></td>
                  <td v-if="item.customers.num == 1" class="td-customer">
                    <span v-if="item.customers.deleted_date !== ''">[退会]</span>
                    <span>{{ item.customers.customer_name }}</span>
                  </td>
                  <td v-else class="td-customer">
                    <span v-if="item.customers.deleted_date !== ''">[退会]</span>
                    <span>{{ item.customers.customer_name }} (他{{ item.customers.num - 1 }} 名)</span>
                  </td>
                  <td class="td-subject"><p>{{ item.subject }}</p></td>
                  <td class="td-send-date"><p>{{ item.last_send_date }}</p></td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      step: 500,
      page_num: 1,
      list: [],
      list_head: [
        {id: 1, title: '送信ID', class: 'th-id'},
        {id: 2, title: '送信対象', class: 'th-customer'},
        {id: 3, title: '件名', class: 'th-subject'},
        {id: 4, title: '送信日', class: 'th-send-date'},
      ],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    page_all_num () { return Math.ceil(this.list.length / this.step); },
    page_list() {
      let start_page = (this.page_num - 1) * this.step;
      return this.list.slice(start_page, start_page + this.step);
    },
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    let ld = new this.$loader(this);
    ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token']});
    ld._post_cb_f = this.send_mail_history_get_cb;
    ld._load_start('manage/send_mail_history_get.php');
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    send_mail_history_get_cb (data) {
      if (data.res === 1) {
        this.list = data.data.list;
      } else {
        this.$alert('alert', `エラーコード：${data.data.res}`);
      }
    },
    send_mail_history_detail_disp (id) {
      this.$router.push({ name: 'mSendMailHistoryDetail', params: { id: String(id) }});
    },
    page_change () {
      if (this.page_all_num < this.page_num) {
        this.page_num = this.page_all_num;
      }
    },
    page_shift (num) {
      let check_num = this.$lib._pint(this.page_num) + num;
      if (check_num > 0 && check_num <= this.page_all_num) {
        this.page_num = check_num;
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .mail-send-history-display {
    min-width: 1108px;
    flex: 1;
    padding: 16px;
    .info-box {
      width: 1060px;
      height: 30px;
      margin: 20px auto 10px auto;
      display: flex;
      justify-content: flex-end;
      .paging-box {
        width: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 30px;
        input[type="text"] {
          text-align: right;
          height: 30px;
          width: 40px;
        }
        div {
          padding: 0 25px;
          margin: 0 10px;
          height: 30px;
          line-height: 32px;
          text-align: center;
          background-color: #cfcebc;
          border-radius: 5px;
          color: #FFF;
          font-weight: bold;
          cursor: pointer;
        }
        div:hover {
          background-color: #738f53;
        }
      }
    }
    .customer-mail-list-box {
      margin: 0 auto;
      width: 1075px;
      table {
        margin: 0 auto;
        thead {
          display:block;
          tr {
            background-color: $manage-table-head-bg-color;
          }
          th {
            border: 1px solid $manage-table-border-color;
            border-bottom: none;
            padding: 5px 0;
          }
          th.th-id {
            width: 80px;
          }
          th.th-customer {
            width: 220px;
            padding: 0 10px;
          }
          th.th-subject {
            width: 500px;
          }
          th.th-send-date {
            width: 230px;
          }
        }
        tbody{
          display:block;
          overflow-y:scroll;
          height: calc(100vh - 170px);
          min-height: 320px;
          width: 1075px;
          td {
            padding: 10px 0;
            border: 1px solid $manage-table-border-color;
          }
          td.td-id {
            width: 80px;
            div {
              cursor: pointer;
              text-decoration: underline;
              color: #9c5360;
            }
            div:hover {
              color: #e91f42;
            }
          }
          td.td-customer {
            width: 220px;
            text-align: left;
            padding: 0 10px;
          }
          td.td-subject {
            text-align: left;
            width: 500px;
          }
          td.td-send-date {
            width: 230px;
          }
        }
      }
    }
  }
}
</style>
